var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancingHeavyEquipment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b2b2b;}.cls-2{fill:#397431;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.18,238.43v-9A102.33,102.33,0,0,0,131,227.27l1.93,8.76A111.25,111.25,0,0,1,109.18,238.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.18,238.43c-40.61,0-66.86-21.14-66.88-53.85,0-20.56,17.62-47.87,52.3-81.22C89.32,96.48,78,81,76.16,72.58a4.48,4.48,0,0,1,1.55-4.45c11-8.91,22.82-6.81,34.28-4.77,7,1.25,14.31,2.55,21.64,1.38a4.49,4.49,0,0,1,5,3.2c2.24,7.83-8,25.41-14.27,35.21,15.7,15.36,30.91,34.7,41.12,52.37L157.73,160c-10.39-18-26.17-37.77-42.22-52.95a4.49,4.49,0,0,1-.66-5.75c6.82-10.22,12.61-21.22,14.54-27.17-6.76.24-13.17-.91-19-1.94-9.64-1.72-17.46-3.11-24.58,1.16C89,80.71,98.27,93.66,104.14,101a4.48,4.48,0,0,1-.42,6.06c-34.29,32.41-52.42,59.22-52.44,77.52,0,21.69,15.23,44.87,57.9,44.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.56,108.29H91.66a4.49,4.49,0,0,1,0-9h35.9a4.49,4.49,0,1,1,0,9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.1,198h-9a13.48,13.48,0,0,1-13.47-13.46,4.49,4.49,0,1,1,9,0,4.5,4.5,0,0,0,4.49,4.49h9a4.5,4.5,0,0,0,4.49-4.49v-2.51a4.48,4.48,0,0,0-3-4.26l-14.68-4.88a13.46,13.46,0,0,1-9.23-12.77v-2.51a13.48,13.48,0,0,1,13.47-13.46h9a13.48,13.48,0,0,1,13.46,13.46,4.49,4.49,0,1,1-9,0,4.49,4.49,0,0,0-4.49-4.48h-9a4.49,4.49,0,0,0-4.49,4.48v2.51a4.5,4.5,0,0,0,3.09,4.26l14.67,4.88a13.43,13.43,0,0,1,9.16,12.77v2.51A13.48,13.48,0,0,1,114.1,198Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.13,
    y: 135.22,
    width: 8.97,
    height: 13.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.13,
    y: 193.55,
    width: 8.97,
    height: 13.46
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.9,238.43H141v-71.8H185.9Zm-35.9-9h26.93V175.6H150Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.8,238.43H176.93V108.29H221.8Zm-35.9-9h26.92V117.27H185.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.7,238.43H212.82V144.19H257.7Zm-35.9-9h26.92V153.17H221.8Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancingHeavyEquipment);
export default __webpack_public_path__ + "static/media/FinancingHeavyEquipment.e5a49336dc62d155ce7c12179cdb32cf.svg";
export { ForwardRef as ReactComponent };